<template>
  <vs-popup
    v-if="popupIsActive"
    :active.sync="popupIsActive"
    class="custom-popup custom-popup--sm"
    @close="$emit('close')"
  >
    <vx-card>
      <div class="vx-card__title mb-4">
        <h2 class="mb-4">{{ currentClient.name }}</h2>
        <div class="person-popup">
          <div class="person-popup-info">
            <div class="person-popup-info__avatar">
              <vs-avatar
                size="44px"
                style="margin: 0"
                :src="currentClient.profile_image_url"
                :text="currentClient.name"
              />
            </div>
            <div class="person-popup-info__desc">
              <div class="person-popup-info__phone">{{ currentClient.phone }}</div>
              <div class="person-popup-info__messenger">
                <div
                  v-if="currentClient.transport_type === 'wa_chat_api'"
                  class="flex items-center"
                >
                  <img
                    src="../../../../assets/images/whatsapp-icon-small.svg"
                    class="icon-message mr-2"
                  >
                  Whatsapp
                </div>
                <div
                  v-if="currentClient.transport_type === 'bachata'"
                  class="flex items-center"
                >
                  <img
                    src="../../../../assets/images/bachata-icon.svg"
                    class="icon-message mr-2"
                  >
                  Bachata
                </div>
              </div>
            </div>
          </div>
          <div class="person-popup-tags">
            <div class="person-popup-tags__input">
              <input-with-dropdown
                class="person-popup-tags-field"
                v-model="tagInput"
                v-validate="'max:16'"
                @enter="onEnterTag"
                name="tag-input"
                :list="uniqueTagsList"
              />
              <span class="text-danger text-sm" v-show="errors.has('tag-input')">{{ errors.first('tag-input') }}</span>
            </div>
            <div
              v-if="editCurrentClient.tags && editCurrentClient.tags.length > 0"
              class="person-popup-tags__list"
            >
              <div class="person-popup-tags-list">
                <div
                  v-for="tag in editCurrentClient.tags"
                  :key="tag.slug"
                  class="person-popup-tags-list__item"
                >
                  <messenger-tag
                    :tag="tag"
                    @delete="onDeleteTag"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mb-5">
            <vs-input
              class="w-full"
              label="Имя: *"
              v-validate="'required'"
              name="name"
              v-model="editCurrentClient.name"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="mb-10">
            <label for="comment" class="vs-input--label">Комментарий:</label>
            <vs-textarea
              class="m-0 mr-4 w-full"
              rows="4"
              v-model="editCurrentClient.description"
              name="comment"
              id="comment"
            />
          </div>
          <div class="flex">
            <div class="w-full mr-2">
              <vs-button
                class="w-full"
                type="border"
                size="medium"
                @click.prevent="$emit('close')"
              >
                Отмена
              </vs-button>
            </div>
            <div class="w-full ml-2">
              <vs-button
                class="w-full"
                size="medium"
                @click.prevent="onSave"
              >
                Сохранить
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
/* eslint no-useless-escape: 0 */

import { mapGetters, mapActions } from 'vuex'
import { copyObject, symmetricDifference } from '@/helpers/helpers'

import Client from '@/api/http/models/Client'
import Tag from '@/api/http/models/Tag'

import InputWithDropdown from '@/components/InputWithDropdown.vue'
import MessengerTag from '@/components/MessengerTag.vue'

export default {
  components: {
    InputWithDropdown,
    MessengerTag
  },

  data () {
    return {
      popupIsActive: false,
      editCurrentClient: {},
      tagInput: '',
      tags: []
    }
  },

  async created () {
    this.editCurrentClient = copyObject(this.currentClient)

    const response = await Tag.getAll(this.authUserCompany.slug)

    this.tags = response.data || []
  },

  computed: {
    ...mapGetters(['authUser', 'authUserCompany', 'currentClient']),
    uniqueTagsList () {
      return symmetricDifference(
        this.tags.map(tag => tag.name),
        this.currentClient.tags.map(tag => tag.name)
      )
    }
  },

  methods: {
    ...mapActions(['mergeClient']),
    async onDeleteTag (tag) {
      this.editCurrentClient.tags = this.editCurrentClient.tags.filter(curTag => curTag.slug !== tag.slug)
    },
    async onEnterTag () {
      let validate = await this.$validator.validate('tag-input')
      const match = this.tagInput.match(/[a-zа-я0-9\.\_\-\s]+/gi)

      if (!(match && match.length > 0 && match[0] === this.tagInput)) {
        validate = false
        this.$validator.errors.add({
          field: 'tag-input',
          msg: 'Используются недопустимые символы.'
        })
      }

      if (this.editCurrentClient.tags.map(tag => tag.name).includes(this.tagInput)) {
        validate = false
        this.$validator.errors.add({
          field: 'tag-input',
          msg: 'Тег должен быть уникальным.'
        })
      }

      if (!validate) return

      this.editCurrentClient.tags.push({
        name: this.tagInput
      })

      this.tagInput = ''
    },
    async onSave () {
      const validate = this.$validator.validate('name')

      if (!validate) return

      const response = await Client.updateOne(this.authUserCompany.slug, this.currentClient.client_id, {
        name: this.editCurrentClient.name,
        description: this.editCurrentClient.description,
        tags: [...this.editCurrentClient.tags.map(tag => tag.name)]
      })

      if (response.status === 'success' && response.data) {
        this.mergeClient({
          id: response.data.id,
          data: response.data
        })
        this.$vs.notify({
          color: 'success',
          title: 'Успешно обновлено',
          text: ''
        })
        this.$emit('close')
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка при обновлении',
          text: ''
        })
      }
    }
  },

  async mounted () {
    this.popupIsActive = true
  }
}
</script>
